// extracted by mini-css-extract-plugin
export var animationContainer = "_ph-0";
export var footer = "_ph-1";
export var gray = "_ph-2";
export var lineItem = "_ph-3";
export var lineItemImage = "_ph-4";
export var lineItemInfo = "_ph-5";
export var lineItemText = "_ph-6";
export var lineItems = "_ph-7";
export var modalContent = "_ph-8";
export var options = "_ph-9";
export var orderName = "_ph-a";
export var refundAmount = "_ph-b";